import HttpService from './http2'

// HTTP client (for the RouteLeaf Data API)
const baseUrl = process.env.VUE_APP_DATA_API_BASE_URL

export const dataApi = new HttpService({
  debug: false,
  timeout: 60 * 1000,
  baseUrl
})
